// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".region-retailers-section[data-v-4d874b0e]{padding:40px 0;text-align:center;font-size:1.25rem;line-height:1.33}.title[data-v-4d874b0e]{margin-bottom:25px;font-weight:700}.intro[data-v-4d874b0e]{text-wrap:balance;max-width:640px;margin-left:auto;margin-right:auto;color:#4a4a49}@media(min-width:576px){.mobile-gutter[data-v-4d874b0e]{padding:0}}.retailer-logos[data-v-4d874b0e]{max-width:720px;margin:0 auto}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
